































































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ListUtils from '@/lib/listUtils';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import WorkerDto from '@/models/Workers/WorkerDto';

@Component({
    name: 'WorkerProfileDetailsEdit'
})
export default class extends GiganautVueDialog {

  public entity = new WorkerDto();
  public editorKey = 0;
  public editorReady = false;

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.editorReady = false;
      this.entity = JSON.parse(JSON.stringify(WorkerDetailsModule.currentWorker));
      this.editorKey++;
      this.$nextTick(() => {
        this.editorReady = true;
      });
    } else {
      this.editorReady = false;
    }
  }

  get loading() {
    return WorkerDetailsModule.loadingDialog;
  }

  get titles() { return ListUtils.titles(); }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    await WorkerDetailsModule.editProfileDetails(this.entity);
    this.dialog = false;
  }
}
